<template>
  <div>
    <!-- Video -->
    <video-view
      :has-fullscreen="false"
      variant="is-blue"
    >
      <!-- Title (first) -->
      <template slot="title-first">
        <div>
          {{ $t("header_5_1") }}

          <div class="underline">
            {{ $t("header_5_2") }}
          </div>
          {{ $t("header_5_3") }}
          <div class="underline">
            {{ $t("header_5_4") }}
          </div>
        </div>
      </template>

      <!-- Video -->
      <video
        autoplay
        muted
        loop
        playsinline
      >
        <source
          type="video/mp4"
          src="https://media.blissapplications.com/videos/desktop-1440-clip-about-us.mp4"
        >
      </video>
    </video-view>

    <!-- About -->
    <about-view v-inview:class="['animate']">
      <span slot="title">
        <div class="underline underline--no-delay underline--primary">
          {{ $t("about_1_1") }}
        </div>
        <div
          class="on-tablet underline underline--no-delay
        underline--primary"
        >
          {{ $t("about_1_4") }}
        </div>
        <div class="underline underline--no-delay underline--primary">
          {{ $t("about_1_2") }}
        </div>
        <div
          class="on-tablet underline underline--no-delay
        underline--primary"
        >
          {{ $t("about_1_4") }}
        </div>
        <div class="underline underline--no-delay underline--primary">
          {{ $t("about_1_3") }}
        </div>
      </span>

      <div slot="content">
        {{ $t("about_2_1") }}
        <br><br>
        {{ $t("about_2_2") }}
        <span class="underline">{{ $t("about_2_3") }}</span>
        <br><br>
        {{ $t("about_2_4") }}
        <a
          href="http://www.wygroup.net"
          target="_blank"
          rel="noopener noreferrer"
          class="underlined primary"
        >{{ $t("about_2_5") }} </a>
        {{ $t("about_2_6") }}
      </div>
    </about-view>

    <!-- About-photo -->
    <about-photo-view />

    <!-- About -->
    <about-view variant="reverse">
      <span slot="title">
        <div class="underline underline--no-delay underline--primary">
          {{ $t("about_3_1") }}
        </div>
        <div
          class="on-tablet underline underline--no-delay
        underline--primary"
        >
          {{ $t("about_1_4") }}
        </div>
        <div
          class="underline
          underline--no-delay
        underline--primary"
        >
          {{ $t("about_3_2") }}
        </div>
        {{ $t("about_3_3") }}</span>
      <div slot="content">
        {{ $t("about_4_1") }}
        <br><br>
        {{ $t("about_4_2_1") }}
        <br><br>
        {{ $t("about_4_2_2") }}
      </div>
    </about-view>

    <!-- Services -->
    <services-full-view />

    <footer-contact-view />
  </div>
</template>

<script>
export default {
  name: 'PageAbout',

  components: {
    VideoView: () => import('@/components/video/video-view'),
    AboutView: () => import('@/components/about/about-view'),
    AboutPhotoView: () => import('@/components/about/about-photo-view'),
    ServicesFullView: () => import('@/components/services/services-full-view'),
    FooterContactView: () => import('@/components/footer/footer-contact-view')
  },

  metaInfo: {
    title: 'About Us: We’re a happy group of design and technology experts',
    meta: [
      {
        name: 'description',
        content:
          'Our diverse talent, whether in Lisbon or Boston, is committed to delivering high quality, on-time to market applications for iOS & Android.'
      },
      {
        property: 'og:url',
        content: 'https://www.blissapplications.com/about-us'
      },
      {
        property: 'og:title',
        content:
          'About Us: We’re a happy group of design and technology experts'
      },
      {
        property: 'og:description',
        content:
          'Our diverse talent, whether in Lisbon or Boston, is committed to delivering high quality, on-time to market applications for iOS & Android.'
      },
      {
        property: 'og:image',
        content: 'https://drive.google.com/file/d/135aIMh5U9N4BSuF0mYkaRy2nx6LCpq1h/view?usp=sharing'
      },
      {
        name: 'twitter:title',
        content:
          'About Us: We’re a happy group of design and technology experts'
      },
      {
        name: 'twitter:description',
        content:
          'Our diverse talent, whether in Lisbon or Boston, is committed to delivering high quality, on-time to market applications for iOS & Android.'
      },
      {
        name: 'twitter:image',
        content: 'https://drive.google.com/file/d/135aIMh5U9N4BSuF0mYkaRy2nx6LCpq1h/view?usp=sharing'
      }
    ]
  },

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// about.vue